import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container,CssBaseline,
    Grid,Button,Paper } from '@material-ui/core';
import omit from 'lodash/omit';
// import moment from 'moment';
import { useHistory,useParams,useLocation } from 'react-router-dom';

import { AppContext } from '../../App';
import axios from '../../utils/axios';
import util from '../../utils/util';

import validate from '../../utils/validate';
import constraint from '../../Constraints/Eleves';
import MyTextField from '../Codification/MyTextField';
import MyDateField from '../Codification/MyDateField';
import MySelectField from '../Codification/MySelectField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }, 
}))
const initData = {
    errors:{}
};
export default function Eleve(){
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams()
    const appContext = React.useContext(AppContext);
    const [eleve,setEleve] = React.useState({...initData})
    const [salles,setSalles] = React.useState([])
    const [view,setView] = React.useState(false);
    const { pathname } = useLocation();
    const fetchData = async ()=>{
        appContext.setOpenLoading(true);
        try {
            const [salles] = await Promise.all([
                axios.get(`/salles`),
            ]);
            if(id){
                const {data} = await axios.get(`/eleves/${id}`);
                let eleve = {
                        id: data.id,
                        nom:data.nom,
                        prenom:data.prenom,
                        telephone:data.telephone,
                        email:data.email,
                        adresse:data.adresse,
                        prenom_pere:data.prenom_pere,
                        prenom_mere:data.prenom_mere,
                        nom_mere:data.nom_mere,
                        date_naissance:data.date_naissance,
                        salle:data.salle.id,
                        errors:{}
                    }
                if(pathname===`/eleves/view/${id}`){
                    setView(true);
                    eleve = {
                        ...eleve,
                        salle:data.salle,
                    }
                }
                setEleve(eleve)
            }
            setSalles(salles.data.results)            
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }
        appContext.setOpenLoading(false);
    }

    React.useEffect(()=>{
        fetchData();
        // eslint-disable-next-line
    },[]);
    const handleChange = (e)=>{
        setEleve({...eleve,[e.target.name]:e.target.value})
    }
    const enregistrer = async (nouveau)=>{
        const errors = validate(eleve,constraint);
        if(errors){
            setEleve({...eleve,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.post(`/eleves`,{...omit(eleve,['errors'])});
            appContext.addMessage('Enregistrement effectué avec succès','success');
            if(nouveau){
                setEleve({...initData})
            }else{
                history.push("/liste-eleves")
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    const modifier = async ()=>{
        const errors = validate(eleve,constraint);
        if(errors){
            setEleve({...eleve,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.put(`/eleves/${eleve.id}`,{...omit(eleve,['errors'])});
            appContext.addMessage('Modification effectué avec succès','success');
            history.goBack()
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Paper className={classes.paper}>

                <Typography variant="h5" gutterBottom>
                    {id ? "Modification" : "Saisie"} Elève
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="matricule"
                            value={eleve.matricule}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Matricule"
                            variant="outlined"
                            disabled={true}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="nom"
                            value={eleve.nom}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Nom"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="prenom"
                            value={eleve.prenom}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Prénom"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="prenom_pere"
                            value={eleve.prenom_pere}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Prénom Père"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="prenom_mere"
                            value={eleve.prenom_mere}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Prénom mère"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MyTextField 
                            name="nom_mere"
                            value={eleve.nom_mere}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Nom mère"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            name="telephone"
                            value={eleve.telephone}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Téléphone"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyTextField 
                            name="email"
                            value={eleve.email}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Email"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MyDateField 
                            name="date_naissance"
                            value={eleve.date_naissance||""}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Date naissance"
                            disabled={view}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="salle"
                                value={eleve.salle && eleve.salle.nom}
                                label="Classe"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="salle"
                                value={eleve.salle}
                                onChange={handleChange}
                                errors={eleve.errors}
                                options={salles}
                                libelle="nom"
                                disabled={view}
                                label="Classe"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                            }}
                            name="adresse"
                            value={eleve.adresse}
                            onChange={handleChange}
                            errors={eleve.errors}
                            label="Adresse"
                            multiline
                            rows="4"
                            variant="outlined"
                            disabled={view}
                            // required={false}
                        />
                    </Grid>
                    
                    {id ?
                        <Grid item xs={12} sm={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={view?history.goBack:modifier}
                            >
                                {view ?'Retour':'Modifier'}
                            </Button>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{display:'flex', justifyContent:'center'}}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(true)}
                                >
                                    Enregistrer & Nouveau
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(false)}
                                >
                                    Enregistrer & Quitter
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Paper>
        </Container>
    )
};